import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-upload-signed-documents',
  templateUrl: './upload-signed-documents.component.html',
  styleUrls: ['./upload-signed-documents.component.scss']
})

export class UploadSignedDocumentsComponent implements OnInit {

  @Input() modalInputs = {
    isInitialSign: true,
    issue: null,
    user: null,
    shouldMakeTransition: true,
    signatoriesList: [],
    documents: []
  };

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {

  }

  onSignUploadCancel(action) {
    action ? this.activeModal.close(action) : this.activeModal.close();
  }
}
